import { createContext, useContext, useMemo, useState } from "react";

const GroomModeContext = createContext({ enabled: false, toggle: () => {} });

const STORAGE_KEY = "groomMode";

// No toggle UI is shown for now — groom mode defaults off. Flip this back to
// reading localStorage once a visible toggle returns.
function readInitial() {
  return false;
}

export function GroomModeProvider({ children }) {
  const [enabled, setEnabled] = useState(readInitial);

  const value = useMemo(
    () => ({
      enabled,
      toggle: () =>
        setEnabled((prev) => {
          const next = !prev;
          try {
            window.localStorage.setItem(STORAGE_KEY, String(next));
          } catch {
            // ignore storage errors (private browsing, etc.)
          }
          return next;
        }),
    }),
    [enabled],
  );

  return <GroomModeContext.Provider value={value}>{children}</GroomModeContext.Provider>;
}

export function useGroomMode() {
  return useContext(GroomModeContext).enabled;
}

export function useGroomModeToggle() {
  return useContext(GroomModeContext).toggle;
}
